import React from 'react'
import { Box, Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material'
import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { useSessionContext } from 'session'
import { type CommitteeBasicInformation } from 'services'
import { cardStyles } from 'components'
import { STATE_CHAMBERS } from 'utils'

interface CommitteeMembersHeaderCardProps {
  committee: CommitteeBasicInformation
  majorityCount: number
  minorityCount: number
  otherCount: number
}

export const CommitteeMembersHeaderCard: React.FC<CommitteeMembersHeaderCardProps> = ({
  committee,
  majorityCount,
  minorityCount,
  otherCount
}) => {
  const { openNewTab } = useSessionContext()
  const isStateCommittee = STATE_CHAMBERS.some(chamber => chamber.id === committee.chamber.id)

  return (
    <Card variant="outlined" sx={cardStyles}>
      <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 2 }}>
        <Box>
          <Typography variant="h6">{committee.name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {isStateCommittee && `${committee.state.desc ?? ''} · `}{committee.chamber.desc} · {committee.role.desc}
          </Typography>
          <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
            <Chip size="small" variant="outlined" label={`${majorityCount + minorityCount + otherCount} members`} />
            <Chip size="small" variant="outlined" label={`${majorityCount} majority`} />
            <Chip size="small" variant="outlined" label={`${minorityCount} minority`} />
            {otherCount > 0 && <Chip size="small" variant="outlined" label={`${otherCount} other`} />}
          </Stack>
        </Box>
        <Stack direction="row" spacing={1}>
          <Button
            variant="outlined"
            size="small"
            startIcon={<OpenInNewIcon />}
            onClick={() => { openNewTab(`/us/committee/edit/${committee.id}`) }}
          >
            Committee
          </Button>
          <Button
            variant="outlined"
            size="small"
            startIcon={<OpenInNewIcon />}
            onClick={() => { openNewTab(`/us/committee/staffers/${committee.id}`) }}
          >
            Staffers
          </Button>
        </Stack>
      </CardContent>
    </Card>
  )
}
